import * as React from 'react';

// COMPONENTS
import RoleListItem from './RoleListItem';
import Button from '../../components/Button';

// ICONS
import { ReactComponent as PlusIcon } from '../../assets/svg/plus.svg';

// TYPES
import { StaffDashboardStaffMember } from '../../api/models';

interface RoleListTypes {
	role: string;
	peopleList: StaffDashboardStaffMember[];
	isPastStaff?: boolean;
}

const RoleList: React.FC<RoleListTypes> = ({ role, peopleList, isPastStaff }) => {
	const [maxItem, setMaxItem] = React.useState<number>(5);

	return (
		<section className="info-section complaints-page">
			{peopleList && peopleList.length > 0 && (
				<>
					<div className="section-header bold">
						{role}
						<span className="quantity">{peopleList.length}</span>
					</div>

					{peopleList.slice(0, maxItem).map((people: StaffDashboardStaffMember) => {
						const { profileImage, firstName, lastName, isYou, staffType, id, canUpdate, needsAttention } = people;

						return (
							<RoleListItem
								key={id}
								profileImage={profileImage}
								firstName={firstName || ''}
								lastName={lastName || ''}
								isYou={isYou}
								staffType={staffType || ''}
								roleId={id || ''}
								canUpdate={canUpdate || false}
								role={role}
								needsAttention={needsAttention}
								isPastStaff={isPastStaff}
							/>
						);
					})}
					{maxItem < peopleList.length && (
						<Button
							buttonIcon={<PlusIcon className="link-icon" />}
							className="btn-secondary btn-show-more"
							type="button"
							onClick={() => setMaxItem(peopleList.length)}
						>
							Show {peopleList.length - maxItem} more
						</Button>
					)}
				</>
			)}
		</section>
	);
};

export default RoleList;
